var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVignette = function SvgIconVignette(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7.25c-1.634 0-3.155.472-4.294 1.285C6.57 9.346 5.75 10.558 5.75 12s.82 2.654 1.956 3.465c1.139.813 2.66 1.285 4.294 1.285s3.155-.472 4.294-1.285c1.136-.811 1.956-2.023 1.956-3.465s-.82-2.654-1.956-3.465C15.155 7.722 13.634 7.25 12 7.25M7.75 12c0-.629.355-1.292 1.119-1.838.762-.544 1.866-.912 3.131-.912s2.37.368 3.131.912c.764.546 1.119 1.21 1.119 1.838s-.355 1.292-1.119 1.838c-.762.544-1.866.912-3.131.912s-2.37-.368-3.131-.912C8.105 13.292 7.75 12.628 7.75 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3.5A1.75 1.75 0 0 0 2 5.25v13.5c0 .966.784 1.75 1.75 1.75h16.5A1.75 1.75 0 0 0 22 18.75V5.25a1.75 1.75 0 0 0-1.75-1.75zm.25 15v-13h16v13z"
  }))));
};
export default SvgIconVignette;